<template>
	<div class="wholesale">
		<div class="wholesale-normal-price" v-if="showNormal">{{ $t('Normal Price') }}: {{ priceDisplay }}</div>
		<div class="form-group d-flex justify-content-between mb-3" v-for="(item, index) in items" :key="index">
			<div class="mr-2 pt-2"><span>&ge;</span></div>
			<div>
				<input
					type="number"
					class="input form-control wholesale-quantity"
					:placeholder="$t('Min. Quantity')"
					min="2"
					:class="{ 'error': isFieldError(index, 'min') && !isFieldDisabled(index) }"
					:disabled="isFieldDisabled(index)"
					:value="item.min"
					@input="onQuantityChange(index, $event)"
				>
				<small class="text-danger" v-if="!isFieldDisabled(index)">{{ getFieldError(index, 'min') }}</small>
			</div>
			<span class="ml-2 mr-2 pt-2">=</span>
			<div>
				<input
					type="text"
					class="input form-control wholesale-price"
					:placeholder="$t('Price')"
					:class="{ 'error': isFieldError(index, 'price') && !isFieldDisabled(index) }"
					:disabled="isFieldDisabled(index)"
					:value="item.price"
					@input="onPriceChange(index, $event)"
				>
				<small class="text-danger" v-if="!isFieldDisabled(index)">{{ getFieldError(index, 'price') }}</small>
			</div>
			<div class="pt-2">
				<i class="material-icons wholesale-delete" @click="remove(index)">close</i>
			</div>
		</div>
		<!-- <wholesale-item v-for="(item, index) in items" :key="index" v-bind.sync="items" /> -->
	</div>
</template>

<script>
import { parseNumber, formatMoney, duplicateVar } from '../lib/helper';
import { defaultWholesaleItem } from '../lib/statics';

export default {
	name: 'wholesale',
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		price: {
			default: 0,
		},
		showNormal: {
			type: Boolean,
			default: true,
		},
		error: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			maxItems: 5,
		};
	},
	methods: {
		checkInitialValues() {
			if (!this.items) {
				this.items = [];
			}
			if (this.items.length === 0) {
				for (let index = 0; index < this.maxItems; index++) {
					this.items.push(duplicateVar(defaultWholesaleItem));
				}
			}
		},
		checkErrors() {
			let isError = false;
			for (let index = 0; index < this.items.length; index++) {
				const isDisabled = this.isFieldDisabled(index);
				const isMinError = this.isFieldError(index, 'min');
				const isPriceError = this.isFieldError(index, 'price');
				isError = !isDisabled && (isMinError || isPriceError);
				if (isError) {
					break;
				}
			}
			this.$emit('update:error', isError);
		},
		change() {
			this.$emit('change', this.items);
			this.$forceUpdate();
			this.checkErrors();
		},
		onQuantityChange(index, e) {
			const value = e.target.value;
			if (value !== '') {
				const parsedValue = parseNumber(value, 2);
				this.items[index].min = parsedValue;
			} else {
				this.items[index].min = value;
			}
			this.change();
		},
		onPriceChange(index, e) {
			const value = e.target.value;
			if (value !== '') {
				const parsedValue = parseNumber(value, 1);
				this.items[index].price = parsedValue;
			} else {
				this.items[index].price = value;
			}
			this.change();
		},
		isFieldDisabled(index) {
			let isInvalid = false;
			const prevIndex = index - 1;
			const prevItem = this.items[prevIndex];
			if (prevItem) {
				const isPrevPriceEmpty = prevItem.price === '';
				const isPrevMinEmpty = prevItem.min === '';
				const isPrevPriceError = this.isFieldError(prevIndex, 'price');
				const isPrevMinError = this.isFieldError(prevIndex, 'min');
				const isPrevDisabled = this.isFieldDisabled(prevIndex);
				isInvalid = isPrevPriceEmpty || isPrevMinEmpty || isPrevPriceError || isPrevMinError || isPrevDisabled;
			}
			return isInvalid;
		},
		getFieldError(index, field) {
			let errorMessage = '';
			const prevIndex = index - 1;
			const prevItem = this.items[prevIndex];
			const item = this.items[index];
			if (item) {
				if (field === 'min') {
					const isMinError = item.price !== '' && item.min === '';
					const isMinNotEmpty = item.min !== '';
					const isValueNotValid = isMinNotEmpty && (item.min === 1 || (prevItem && item.min <= prevItem.min));
					const isError = isMinError || isValueNotValid;
					if (isError) {
						errorMessage = 'Minimum quantity is not valid.';
					}
				} else if (field === 'price') {
					const isPriceHigher = prevItem && item.price >= prevItem.price;
					const isFirstPriceHigher = index === 0 && item.price >= this.price;
					const isPriceEmtpy = item.min !== '' && item.price === '';
					if (isPriceEmtpy || item.price === 0) {
						errorMessage = 'Price is not valid.';
					} else if (isPriceHigher) {
						errorMessage = 'Price must be cheaper.';
					} else if (isFirstPriceHigher) {
						errorMessage = 'Must be cheaper than normal price.';
					}
				}
			}
			return errorMessage;
		},
		isFieldError(index, field) {
			const error = this.getFieldError(index, field);
			return error.length > 0;
		},
		remove(index) {
			for (let i = index; i < this.items.length; i++) {
				this.items[i].min = '';
				this.items[i].price = '';
			}
			this.change();
		},
	},
	computed: {
		priceDisplay() {
			return formatMoney(this.price);
		},
	},
	created() {
		this.checkInitialValues();
		this.checkErrors();
	},
};
</script>
